/* src/app/shared-module/components/dialog-link-property/dialog-link-property.component.scss */
.dlp-header {
  display: flex;
  align-items: center;
  gap: 12px;
  background: var(--ion-color-secondary-shade);
  color: white;
  margin: 0;
  padding: 14px 16px 14px 16px;
  border-radius: 4px 4px 0 0;
}
.dlp-header .dlp-header-icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.18);
  flex-shrink: 0;
}
.dlp-header .dlp-header-icon-wrap ion-icon {
  font-size: 20px;
  color: white;
}
.dlp-header .dlp-header-text {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
}
.dlp-header .dlp-header-text .dlp-header-title {
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 0.2px;
  color: white;
  line-height: 1.3;
}
.dlp-header .dlp-header-text .dlp-header-subtitle {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.75);
  margin-top: 2px;
}
.dlp-header .dlp-close-btn {
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  padding: 0;
  flex-shrink: 0;
  transition: background 0.2s;
}
.dlp-header .dlp-close-btn ion-icon {
  font-size: 20px;
  color: rgba(255, 255, 255, 0.85);
}
.dlp-header .dlp-close-btn:hover {
  background: rgba(255, 255, 255, 0.15);
}
.dlp-content {
  padding: 16px 16px 4px 16px !important;
  overflow: visible !important;
}
.dlp-content .dlp-info-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 14px;
}
.dlp-content .dlp-info-row .dlp-info-icon-box {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: var(--ion-color-primary-tint);
  flex-shrink: 0;
}
.dlp-content .dlp-info-row .dlp-info-icon-box ion-icon {
  font-size: 18px;
  color: var(--ion-color-secondary-shade);
}
.dlp-content .dlp-info-row .dlp-info-label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: var(--ion-color-secondary-shade);
  line-height: 1.3;
}
.dlp-content .dlp-info-row .dlp-info-caption {
  display: block;
  font-size: 11.5px;
  color: #777;
  margin-top: 2px;
  line-height: 1.4;
}
.dlp-content .dlp-url-card {
  margin: 0 0 12px 0;
  border-radius: 10px !important;
  box-shadow: 0 2px 8px rgba(32, 59, 114, 0.1) !important;
  border: 1.5px solid var(--ion-color-primary-shade);
}
.dlp-content .dlp-url-card .dlp-url-card-content {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px !important;
}
.dlp-content .dlp-url-card .dlp-url-card-content .dlp-url-icon-col {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 6px;
  background: var(--ion-color-primary-tint);
  flex-shrink: 0;
}
.dlp-content .dlp-url-card .dlp-url-card-content .dlp-url-icon-col ion-icon {
  font-size: 16px;
  color: var(--ion-color-secondary-shade);
}
.dlp-content .dlp-url-card .dlp-url-card-content .dlp-url-text {
  flex: 1;
  font-size: 12.5px;
  color: #1565c0;
  word-break: break-all;
  text-decoration: none;
  line-height: 1.5;
}
.dlp-content .dlp-url-card .dlp-url-card-content .dlp-url-text:hover {
  text-decoration: underline;
}
.dlp-content .dlp-url-card .dlp-url-card-content .dlp-open-btn {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 4px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.dlp-content .dlp-url-card .dlp-url-card-content .dlp-open-btn a {
  display: flex;
  align-items: center;
  color: var(--ion-color-secondary-shade);
  text-decoration: none;
}
.dlp-content .dlp-url-card .dlp-url-card-content .dlp-open-btn a ion-icon {
  font-size: 17px;
}
.dlp-content .dlp-tip-row {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 10px;
  background: #fff8e1;
  border-radius: 6px;
  border-left: 3px solid #ffc107;
  margin-bottom: 4px;
}
.dlp-content .dlp-tip-row ion-icon {
  font-size: 15px;
  color: #e65100;
  flex-shrink: 0;
}
.dlp-content .dlp-tip-row span {
  font-size: 11.5px;
  color: #795548;
  line-height: 1.4;
}
.dlp-actions {
  display: flex !important;
  justify-content: flex-end !important;
  gap: 8px;
  padding: 10px 16px 14px 16px !important;
  border-top: 1px solid var(--ion-color-primary-shade);
  margin: 0 !important;
}
.dlp-actions .dlp-btn {
  --box-shadow: none !important;
  --border-radius: 8px;
  height: 38px;
  font-size: 13px;
  font-weight: 600;
}
.dlp-actions .dlp-btn--primary {
  --background: var(--ion-color-secondary-shade) !important;
  color: white;
  transition: opacity 0.2s;
}
.dlp-actions .dlp-btn--primary:hover {
  opacity: 0.88;
}
.dlp-actions .dlp-btn--secondary {
  --border-color: var(--ion-color-secondary-shade) !important;
  --color: var(--ion-color-secondary-shade) !important;
}
/*# sourceMappingURL=dialog-link-property.component.css.map */
